import { useEffect, useRef, useState } from 'react';

/**
 * What you can do to your own post, behind one control.
 *
 * A row of equal-weight buttons puts Delete beside Edit and asks everyone to
 * read four labels on every post they own. Every platform hides this behind a
 * single glyph for the same reason.
 */
export default function PostMenu({ items }) {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (event) => { if (!boxRef.current?.contains(event.target)) setOpen(false); };
    const onKey = (event) => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    window.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const usable = items.filter(Boolean);
  if (usable.length === 0) return null;

  return (
    <div className="postmenu" ref={boxRef}>
      <button
        type="button"
        className="postmenu-trigger"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="Post options"
        onClick={() => setOpen((v) => !v)}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true">
          <circle cx="5" cy="12" r="1.8" /><circle cx="12" cy="12" r="1.8" /><circle cx="19" cy="12" r="1.8" />
        </svg>
      </button>

      {open && (
        <div className="postmenu-list" role="menu">
          {usable.map((item) => (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              className={`postmenu-item ${item.danger ? 'danger' : ''}`}
              onClick={() => { setOpen(false); item.onSelect(); }}
            >
              <span className="postmenu-label">{item.label}</span>
              {item.hint && <span className="postmenu-hint">{item.hint}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
